// extracted by mini-css-extract-plugin
export default {"ScrollRightArrow":"ScrollRightArrow_ScrollRightArrow__Z4kFH"};